import { CONTRACT_STATUS } from 'services/contract/types';
import { IContractTemplateForm } from 'services/templates/types';
import { formatDateToInput } from 'utils/global/date.utils';

export const contractTemplateFormInitialValue: IContractTemplateForm = {
  activeId: null,
  overId: null,
  offsetLeft: 0,
  sideMenu: null,
  items: [],
  version: 0,
};
